import * as React from "react";

function SvgIcRetireDate(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.611 17.09H5.436l1.27-1.42a.47.47 0 00.08-.493.434.434 0 00-.397-.272H4.453a.445.445 0 00-.435.454c0 .251.195.455.435.455h.934l-1.27 1.42a.47.47 0 00-.08.492.433.433 0 00.397.274h2.177c.24 0 .435-.204.435-.455a.446.446 0 00-.435-.456zM11.717 13.88h-1.54l1.698-1.9a.707.707 0 00.121-.738.65.65 0 00-.598-.41h-2.75c-.36 0-.652.305-.652.681 0 .377.292.683.652.683h1.249L8.2 14.095a.708.708 0 00-.122.739c.103.248.338.41.598.41h3.04c.36 0 .652-.306.652-.682 0-.377-.292-.683-.651-.683zM19.13 10.808h-2.709l2.929-3.277a.941.941 0 00.162-.983.867.867 0 00-.796-.548h-4.379c-.48 0-.868.408-.868.91s.388.91.869.91h2.374l-2.928 3.277a.94.94 0 00-.162.983.868.868 0 00.797.549h4.712c.48 0 .869-.408.869-.91s-.39-.91-.87-.91z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcRetireDate;
